import { Link } from 'react-router-dom';

import { asset } from "Services/BaseHelpers";

const Logo = () => {
    return (
        <div className="absolute top-5 left-5 lg:top-10 lg:left-10 z-20">
            <Link to="/dashboard">
                <img 
                    src={asset('/images/hazard/ee-logo.png')} 
                    className="w-8 lg:w-16"
                />
            </Link>
        </div>
    );
};

export default Logo;
